import type { ReactNode } from "react";
import { LogOut } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { Button } from "@/components/ui";

/**
 * Shared chrome for the signed-in areas: a 44px header bar and a max-width
 * content column. Deliberately plain — the page content is the product.
 */
export function AppShell({
  title,
  actions,
  children,
}: {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-app">
      <header className="sticky top-0 z-10 border-b border-border bg-surface">
        <div className="mx-auto flex h-11 max-w-6xl items-center gap-3 px-4">
          <span className="text-xs font-semibold tracking-tight text-ink">
            Exam Proctor
          </span>
          <span className="text-border-strong">/</span>
          <span className="truncate text-xs text-ink-muted">{title}</span>

          <div className="ml-auto flex items-center gap-3">
            {actions}
            {user ? (
              <>
                <span className="hidden text-2xs text-ink-faint sm:inline">
                  {user.name} · {user.role}
                </span>
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<LogOut />}
                  onClick={() => void logout()}
                >
                  Sign out
                </Button>
              </>
            ) : null}
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6">{children}</main>
    </div>
  );
}
